<template>
    <div class="data-wrapper-core">
        <h3>Kerndaten</h3>
        <v-divider></v-divider>
        <h4>Kampagnen-Name:</h4>
        <p>{{ tables.occupation }}</p>
        <h4>Leads Löschen-Button sichtbar:</h4>
        <p :style="{ color: tables.deleteLeadVisible ? 'green' : 'red' }">{{ tables.deleteLeadVisible }}</p>
        <h4>Vorqualifizierung:</h4>
        <p :style="{ color: tables.prequalify ? 'green' : 'red' }">{{ tables.prequalify }}</p>
        <h4>Erstelldatum:</h4>
        <p>{{ tables.createdAt }}</p>
        <h4>Kampagnen-ID:</h4>
        <p>{{ tables._id }}</p>
        <h4>Funnel-Link:</h4>
        <p>{{ tables.funnelLink }}</p>
        <h4>Zuletzt verändert:</h4>
        <p>{{ tables.lastChange }}</p>
        <h4>Webhooktoken:</h4>
        <p>{{ tables.webhooktoken }}</p>    
    </div>
</template>

<script>
    export default {
        props: {
            tables: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>